export const modal_open_image = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40rem',
    height: '40rem',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '@media (max-width: 768px)': {
        width: '24rem',
        height: '24rem',
    },
}

export const buttons_close = {
    position: 'absolute' as const,
    top: '10px',
    right: '10px',
}